import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';

import '../../theme/global.scss';
import styles from '../../pages/monitorization/monitorization.module.scss';
import {
  IActionDocument,
  IMeasure,
  IMeasureAction
} from '../../utils/interfaces/interfaces';
import { formatDate } from '../../utils/strings';
import CDropdown from '../dropdown/dropdown';
import { TypeStatus, types_statuses } from '../../types/menu-statuses';
import {
  checkFilesHaveSameType,
  combineFiles,
  fileFormat,
  handleFileChange,
  initialFile
} from '../../utils/files';
import CSwitch from '../switch/switch';
import CUpload from '../input/upload';
import { notify } from '../../notifications/notification';
import {
  addActionDeadline,
  addActionDeadlineWithDoc,
  addActionStatus,
  addActionStatusWithDoc
} from '../../network/measure';
import { measuresTypes, TMeasure } from '../../types/measures';
import { typesFiles } from '../../types/uploaded-data';

interface IPMeasure {
  callback?: () => void;
  idMonitorization: number;
  selectedMeasure: IMeasure;
  type: TMeasure;
  documents: any[];
}

const initialForm: IMeasureAction = {
  prolongedDeadline: new Date(),
  status: types_statuses[0].name,
  decisionDocument: fileFormat,
  decisionDocumentDescription: '',
  decisionDocumentName: '',
  decisionMeasureActionDescription: '',
  decisionMeasureId: 0,
  decisionDocumentId: 0
};

const EditMeasure = (props: IPMeasure) => {
  const [form, updateForm] = useState(initialForm);

  const [status, setStatus] = useState(types_statuses[0]);
  const [editingItem, setEditingItem] = useState('status');
  const [document, setDocument] = useState(initialFile);
  const [selectedDocument, setSelectedDocument] = useState(
    {} as IActionDocument
  );

  const [submitNew, setTypeSubmit] = useState(false);

  useEffect(() => {
    updateForm(form => ({ ...form, decisionId: props.idMonitorization }));
  }, [props.idMonitorization]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event && event.target && event.target.value.length < 100) {
      const { value, name } = event.target;
      updateForm(form => ({ ...form, [name]: value }));
    }
  };

  const handleDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    new Date(value) &&
      updateForm(form => ({ ...form, [name]: new Date(value) }));
  };

  const handleStatus = (item: TypeStatus) => {
    setStatus(item);
  };

  const handleSelectedDoc = (item: any) => {
    setSelectedDocument(item);
  };

  const handleFile = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFile: any
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      if (!checkFilesHaveSameType(event.target.files, typesFiles.pdf)) {
        notify('Trebuie sa incarcati documente de tip PDF', 'info');
        return;
      }
    }
    handleFileChange(event, setFile);
  };

  const handleSubmit = async (event: React.MouseEvent) => {
    /* prevent from reloading */
    event.preventDefault();
    const decisionDocument = await combineFiles(
      document,
      form.decisionDocumentName
    );

    if (submitNew) {
      /* submit request */
      if (editingItem === 'status') {
        const {
          decisionDocumentDescription,
          decisionDocumentName,
          decisionMeasureActionDescription
        } = form;

        addActionStatus({
          decisionDocument,
          decisionDocumentDescription,
          decisionDocumentName,
          decisionMeasureActionDescription,
          decisionMeasureId: props.selectedMeasure.id,
          status: status.key
        }).then(() => {
          notify('Ati submis cu succes actiunea', 'success');
          props.callback && props.callback();
        });

        return;
      }

      if (editingItem === 'deadline') {
        const {
          decisionDocumentDescription,
          decisionDocumentName,
          decisionMeasureActionDescription,
          prolongedDeadline
        } = form;
        addActionDeadline({
          decisionDocument,
          decisionDocumentDescription,
          decisionDocumentName,
          decisionMeasureActionDescription,
          decisionMeasureId: props.selectedMeasure.id,
          prolongedDeadline: prolongedDeadline.toISOString()
        }).then(() => {
          notify('Ati submis cu succes actiunea', 'success');
          props.callback && props.callback();
        });

        return;
      }
    } else {
      /* submit request */
      if (editingItem === 'status') {
        const { decisionMeasureActionDescription } = form;

        addActionStatusWithDoc({
          decisionDocumentId: selectedDocument.id,
          decisionMeasureActionDescription,
          decisionMeasureId: props.selectedMeasure.id,
          status: status.key
        }).then(() => {
          notify('Ati submis cu succes actiunea', 'success');
          props.callback && props.callback();
        });

        return;
      }

      if (editingItem === 'deadline') {
        const { decisionMeasureActionDescription, prolongedDeadline } = form;
        addActionDeadlineWithDoc({
          decisionDocumentId: selectedDocument.id,
          decisionMeasureActionDescription,
          decisionMeasureId: props.selectedMeasure.id,
          prolongedDeadline: prolongedDeadline.toISOString()
        }).then(() => {
          notify('Ati submis cu succes actiunea', 'success');
          props.callback && props.callback();
        });

        return;
      }
    }
  };

  return (
    <form>
      <p className='body-dark bold'>
        Editare{' '}
        {props.type === measuresTypes.MEASURES ? 'măsură' : 'recomandare'}
      </p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      <p className='body-dark inputWidth'>Editati statusul sau termenul?</p>
      <Space vertical={'30px'} />
      <CInput
        label='Status'
        type='radio'
        id='status'
        name='type'
        value={editingItem}
        checked={editingItem === 'status'}
        onChange={e => {
          setEditingItem('status');
        }}
      />

      <CInput
        label='Termenul prelungit'
        type='radio'
        id='deadline'
        name='type'
        value={editingItem}
        checked={editingItem === 'deadline'}
        onChange={e => {
          setEditingItem('deadline');
        }}
      />

      <Space vertical={'30px'} />

      <CInput
        label='Descriere actiune'
        type='text'
        id='decisionMeasureActionDescription'
        placeholder='descrierea actiunii'
        name='decisionMeasureActionDescription'
        value={form.decisionMeasureActionDescription}
        onChange={handleChange}
        required
      />
      {editingItem === 'status' && (
        <CDropdown
          label='Status'
          placeholder='Status'
          visibleKey='name'
          currentOption={status}
          onChange={handleStatus}
          list={types_statuses}
          className={styles.dropdownStatuses}
          viewOnly
        />
      )}
      {editingItem === 'deadline' && (
        <CInput
          label='Termen prelungit'
          type='date'
          id='date'
          // placeholder='prolongedDeadline'
          name='prolongedDeadline'
          value={formatDate(form.prolongedDeadline)}
          onChange={handleDate}
          required
        />
      )}
      <CSwitch
        value={submitNew}
        label={'Doriți să încărcați un document nou?'}
        onChecked={() => setTypeSubmit(!submitNew)}
      />
      {!submitNew && (
        <CDropdown
          label='Document'
          placeholder='Alegeți un document'
          visiblePhrase={el => (el ? `${el.name}` : '')}
          currentOption={selectedDocument}
          onChange={handleSelectedDoc}
          list={props.documents}
          className={styles.dropdownStatuses}
        />
      )}
      {submitNew && (
        <>
          <CInput
            label='Nume document'
            type='text'
            id='name'
            placeholder='Numele documentului'
            name='decisionDocumentName'
            value={form.decisionDocumentName}
            onChange={handleChange}
            required
          />
          <CInput
            label='Descriere document'
            type='text'
            id='description'
            placeholder='Descrierea documentului'
            name='decisionDocumentDescription'
            value={form.decisionDocumentDescription}
            onChange={handleChange}
            required
          />
          <CUpload
            label='Încărcați documentul'
            title='Încărcați documentul'
            id='document'
            name=''
            value={document}
            onChange={e => handleFile(e, setDocument)}
          />
        </>
      )}

      <Space vertical={'30px'} />
      <CButton label='Salveaza' type='submit' onClick={handleSubmit} />
    </form>
  );
};

export default EditMeasure;
